import { render, staticRenderFns } from "./AllItems.vue?vue&type=template&id=20b7fb3c&"
import script from "./AllItems.vue?vue&type=script&lang=js&"
export * from "./AllItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports